const validatePassword = (password) => {
  const hasLowercase = /[a-z]+/.test(password);
  const hasUppercase = /[A-Z]+/.test(password);
  const hasNumber = /[0-9]+/.test(password);
  const hasLength = password.length >= 8;
  const hasSpecial = /[\W_]+/.test(password);
  const isValid = hasLowercase && hasUppercase && hasNumber && hasLength && hasSpecial;

  return {
    lowercase: hasLowercase,
    uppercase: hasUppercase,
    special: hasSpecial,
    length: hasLength,
    number: hasNumber,
    valid: isValid,
  };
};

const generatePassword = () => {
  const length = 12;
  const numberChars = '0123456789';
  const upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowerChars = 'abcdefghijklmnopqrstuvwxyz';
  const specialChars = '~!@-#${}/';
  const allChars = numberChars + upperChars + lowerChars + specialChars;

  let randPasswordArray = Array(length);
  randPasswordArray[0] = numberChars;
  randPasswordArray[1] = upperChars;
  randPasswordArray[2] = lowerChars;
  randPasswordArray[3] = specialChars;
  randPasswordArray = randPasswordArray.fill(allChars, 4);
  return shuffleArray(
    randPasswordArray.map(function (x) {
      return x[Math.floor(Math.random() * x.length)];
    }),
  ).join('');
};

const shuffleArray = (array) => {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};
export { validatePassword, generatePassword };
